import { useIsUserActingAsATMStore } from '../../../CalendarStore';
import { useEffect } from 'react';
import { useReactiveVar } from '@apollo/client';
import { userPrivileges } from '@apollo-internal/cache';
import PrivilegeNames from '../../../../../constants/privilegeNames';
import { useShallow } from 'zustand/shallow';

const useDefaultUserActingAsATM = () => {
  const privileges = useReactiveVar(userPrivileges);

  const defaultIsUserActingAsATM = privileges.includes(PrivilegeNames.Calendar_ATMToggle)
    ? false
    : null;

  const isUserActingAsATM = useIsUserActingAsATMStore(
    useShallow(state => state.isUserActingAsATM || defaultIsUserActingAsATM)
  );
  const setIsUserActingAsATM = useIsUserActingAsATMStore(state => state.setIsUserActingAsATM);

  useEffect(() => {
    setIsUserActingAsATM(isUserActingAsATM);
  }, [setIsUserActingAsATM, isUserActingAsATM]);

  return isUserActingAsATM;
};

export default useDefaultUserActingAsATM;
